export default __webpack_public_path__ + "static/media/dog-tablet.7443fd94.png";